import { ButtonProps, IconButton } from "@chakra-ui/react"
import { Dispatch, ReactElement, SetStateAction } from "react"

type Props = ButtonProps & {
  icon: ReactElement
  ariaLabel: string
  setRef: Dispatch<SetStateAction<HTMLElement>>
}

export const GalleryNavigationButton = ({ icon, width, ariaLabel, setRef, height }: Props) => {
  return (
    <IconButton
      backgroundColor="transparent"
      minW={{ base: "11", lg: "10" }}
      height={height}
      width={width}
      icon={icon}
      aria-label={ariaLabel}
      ref={(node) => setRef(node)}
      _hover={{
        "@media (hover: hover) and (pointer: fine)": { bgColor: "gray.200" },
        _disabled: { bgColor: "transparent" },
      }}
      _disabled={{ cursor: "default", color: "gray.350" }}
      _active={{ bgColor: "gray.900", color: "white" }}
    />
  )
}
